import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DataTransferServiceService } from 'src/app/services/data-transfer-service.service';
import { BASEURLS, BOOKTYPES, CATEGORYTYPES, LISTTYPE, PARENTCATEGORYTYPES } from 'src/app/config/constants';
import { HttpClient } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit {
  data: any[] = [];
  videoCategories: any[] = [];
  bookCategories: any[] = [];
  gameArray = [
    {
      caId: null,
      caTitle: 'Games',
      caDescription: 'Fun and educational games for kids',
      caDp: 'assets/Images/Sitted_Mascot_Night.png',
      caStatus: 'ACTIVE',
      type: 'game',
      externalLink: 'https://lil-champs.com/games/healthy-hero/'
    }
  ];

  constructor(
    private dataTransferService: DataTransferServiceService,
    private toastr: ToastrService,
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.loadAllCategories();
    const currentUrl = window.location.href;
    this.dataTransferService.logPageVisitByIp(currentUrl);
  }
  loadAllCategories(): void {
    const videoPayload = {
      caTitle: PARENTCATEGORYTYPES.VIDEOS,
      caType: LISTTYPE.SERIES
    };

    const bookPayload = {
      caTitle: PARENTCATEGORYTYPES.EBOOKS,
      caType: LISTTYPE.CATEGORY
    };

    this.spinner.show('globalSpinner');

    Promise.all([
      this.dataTransferService.getAllDataByCategory(videoPayload).toPromise(),
      this.dataTransferService.getAllDataByCategory(bookPayload).toPromise()
    ])
      .then(([videoRes, bookRes]: any) => {
        this.videoCategories = videoRes.data.map((cat: any) => ({
          caId: cat.seriesId,
          caTitle: cat.seriesName,
          caDescription: cat.caDescription,
          caDp: cat.caDp ? `${BASEURLS.S3URL}${cat.caDp.trim()}` : null,
          caStatus: cat.caStatus,
          type: 'video'
        }));

        this.bookCategories = bookRes.data[0].subcategories.map((cat: any) => ({
          caId: cat.caId,
          caTitle: cat.caTitle,
          caDescription: cat.caDescription,
          caDp: cat.caDp ? `${BASEURLS.S3URL}${cat.caDp.trim()}` : null,
          caStatus: cat.caStatus,
          type: 'book'
        }));

        this.data = [
          ...this.videoCategories,
          ...this.gameArray,
          ...this.bookCategories
        ];
      })
      .catch(() => {
        this.toastr.error('Failed to load categories');
      })
      .finally(() => {
        this.spinner.hide('globalSpinner');
      });
  }


  cardRoute(item: any) {
    if (item.type === 'video') {
      this.router.navigate([`/videos`], {
        queryParams: {
          seriesId: item.caId,
          seriesName: item.caTitle,

        }
      })
    } else {
      this.router.navigate([`/books`], {
        queryParams: {
          caId: item.caId,
          caTitle: item.caTitle
        }
      })
    }
  }

}
